import { observer } from "mobx-react";
import { VBox } from "../../components-v2/Box";
import {
  adminFollowUpCompanyInfo,
  adminFollowUpMatters,
  adminFollowUpShareholders,
  adminFollowUpSignatures,
} from "../../utils/navigation";
import {
  extractFollowUpShareholdersUrl,
  extractPortfolioFollowUpCompanyInfoUrl,
  extractPortfolioFollowUpMattersUrl,
  extractPortfolioFollowUpSignaturesUrl,
  SelectedPortfolioOption,
} from "../portfolioDomain";
import { MenuItem } from "../../components-v2/MenuBar";

export const FollowUpLeftPanel = observer(function FollowUpLeftPanel({
  portfolio,
  selectedTab,
  showAdminLinks,
  signDocumentCount,
  followUpMattersCount,
  companyInfoCount,
  followUpShareholdersCount,
  contextCompany,
}: {
  portfolio: SelectedPortfolioOption;
  selectedTab: "signatures" | "matters" | "company-info" | "shareholders";
  showAdminLinks: boolean;
  signDocumentCount?: number;
  followUpMattersCount?: number;
  companyInfoCount?: number;
  followUpShareholdersCount?: number;
  contextCompany?: string;
}) {
  signDocumentCount = signDocumentCount ?? 0;
  followUpMattersCount = followUpMattersCount ?? 0;
  companyInfoCount = companyInfoCount ?? 0;
  followUpShareholdersCount = followUpShareholdersCount ?? 0;
  const mattersUrl = contextCompany
    ? `${adminFollowUpMatters(contextCompany)}`
    : extractPortfolioFollowUpMattersUrl(portfolio);
  const signaturesUrl = contextCompany
    ? `${adminFollowUpSignatures(contextCompany)}`
    : extractPortfolioFollowUpSignaturesUrl(portfolio);
  const companyInfoUrl = contextCompany
    ? `${adminFollowUpCompanyInfo(contextCompany)}`
    : extractPortfolioFollowUpCompanyInfoUrl(portfolio);
  const shareholdersUrl = contextCompany
    ? `${adminFollowUpShareholders(contextCompany)}`
    : extractFollowUpShareholdersUrl(portfolio);
  return (
    <VBox padding={"md"}>
      <MenuItem
        icon={"pen"}
        text={{ key: "header.signatures" }}
        url={signaturesUrl}
        isActive={selectedTab === "signatures"}
        tag={signDocumentCount > 0 ? { translated: String(signDocumentCount) } : undefined}
      />
      {showAdminLinks && (
        <>
          <MenuItem
            icon={"gavel"}
            text={{ key: "portfolio.matters" }}
            url={mattersUrl}
            isActive={selectedTab === "matters"}
            tag={
              followUpMattersCount > 0 ? { translated: String(followUpMattersCount) } : undefined
            }
          />
          <MenuItem
            icon={"buildings"}
            text={{ key: "portfolio.company-info" }}
            url={companyInfoUrl}
            isActive={selectedTab === "company-info"}
            tag={companyInfoCount > 0 ? { translated: String(companyInfoCount) } : undefined}
          />
          <MenuItem
            icon={"notebook"}
            text={{ key: "followup.shareholders" }}
            url={shareholdersUrl}
            isActive={selectedTab === "shareholders"}
            tag={
              followUpShareholdersCount > 0
                ? { translated: String(followUpShareholdersCount) }
                : undefined
            }
          />
        </>
      )}
    </VBox>
  );
});
